export const iconFontAwesomeDesignPencil = (
	<i className="fa-solid fa-pencil"></i>
);
